module.exports = __webpack_public_path__ + "static/media/starHalf.22bab823.svg";